"use client";

// Filterkopf der Vorlagenliste: Suche und die Art der Vorlage.
import { Filterkopf, Filterzurueck, Fuge, Luecke, Suchfeld, useAnsicht, Zaehlknopf, Zaehlschiene } from "@/components/liste";
import { TEMPLATE_KIND } from "@/lib/labels";
import { VORLAGEN_ARTEN, VORLAGEN_PARAMS, type VorlagenAnsicht } from "@/lib/nachrichten/ansicht";

export function VorlagenFilterkopf({ ansicht, gesamt, artZaehler }: { ansicht: VorlagenAnsicht; gesamt: number; artZaehler: Record<string, number> }) {
  const { setzen, isPending } = useAnsicht();
  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={ansicht.q} platzhalter="Name, Betreff, Text …" beschriftung="Vorlagen durchsuchen" />
          <Luecke />
          <Zaehlschiene titel="Art">
            <Zaehlknopf label="Alle" sammel anzahl={gesamt} aktiv={ansicht.art === ""} onClick={() => setzen({ art: null })} />
            <Fuge />
            {VORLAGEN_ARTEN.map((k) => (
              <Zaehlknopf
                key={k}
                label={TEMPLATE_KIND[k]}
                anzahl={artZaehler[k] ?? 0}
                aktiv={ansicht.art === k}
                onClick={() => setzen({ art: ansicht.art === k ? null : k })}
              />
            ))}
          </Zaehlschiene>
          <Filterzurueck anzahl={[ansicht.q, ansicht.art].filter(Boolean).length} params={VORLAGEN_PARAMS} />
        </>
      }
    />
  );
}
